module.exports = __webpack_public_path__ + "static/img/help_12excel_01.322d8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_12excel_01.png
// module id = 713
// module chunks = 140